'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createAction = undefined;

var _keyMirror = require('react-utils/keyMirror');

var _keyMirror2 = _interopRequireDefault(_keyMirror);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = Object.assign({ RAW_LOCATION_CHANGE: '@@router/LOCATION_CHANGE' }, (0, _keyMirror2.default)({
  LOCATION_CHANGE: null,

  APP_STARTED: null,

  BOOTSTRAPPED: null,

  USER_ASK_EARLY: null,
  USER_ASK: null,
  USER_LOAD_FAIL: null,
  USER_LOADED: null,

  USERS_ASK_START: null,
  USERS_ASK: null,
  USERS_LOADED: null,
  USERS_ASK_PAGE: null,

  USER_EDIT: null,
  USER_CANCEL: null,
  USER_SAVE: null,
  USER_SAVED: null,

  AVATAR_UPLOAD: null,
  AVATAR_UPLOADED: null,
  AVATAR_GRAVATAR: null,
  AVATAR_DELETE: null,
  AVATAR_CHANGED: null,

  FOLLOW: null,
  UNFOLLOW: null,
  FOLLOWED: null,
  UNFOLLOWED: null,

  TOY_LIST_ASK: null,
  TOY_LIST_LOADED: null,

  FAIL: null
}));
var createAction = exports.createAction = function createAction(type, payload) {
  return { type: type, payload: payload };
};


//////////////////
// WEBPACK FOOTER
// ./js/actions.js
// module id = 48
// module chunks = 171